import { render, staticRenderFns } from "./agency-settings.vue?vue&type=template&id=56d65671&"
import script from "./agency-settings.vue?vue&type=script&lang=js&"
export * from "./agency-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports